import { render, staticRenderFns } from "./AdminReported.vue?vue&type=template&id=36a50e38&scoped=true"
import script from "./AdminReported.vue?vue&type=script&lang=js"
export * from "./AdminReported.vue?vue&type=script&lang=js"
import style0 from "./AdminReported.vue?vue&type=style&index=0&id=36a50e38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a50e38",
  null
  
)

export default component.exports